// Folder 공유 API 서비스
//
// 요청은 공용 axios 클라이언트(apiService.client)를 사용한다.
// 수동 Authorization 헤더를 쓰던 raw fetch 구현은 토큰 갱신·에러 정규화·
// 도메인별 baseURL 처리를 모두 우회했다.

import { apiService } from './api'

export interface SharedFolder {
  _id: string
  name: string
  description?: string
  color: string
  icon: string
  owner: { _id: string; username: string; email: string } | null
  team: { _id: string; name: string } | null
  allowTeamEdit: boolean
  canEdit: boolean
  linkCount: number
  updatedAt: string
}

export interface ShareFolderInput {
  teamId: string
  allowTeamEdit?: boolean
}

export interface FolderPermissionsInput {
  allowTeamEdit?: boolean
  canEdit?: string[]
  canView?: string[]
}

// 폴더 라우트는 data 봉투 없이 최상위 키로 응답한다 (예: { success, folders })
interface ApiEnvelope {
  success: boolean
  message?: string
  folders?: SharedFolder[]
  folder?: SharedFolder
  [key: string]: unknown
}

export class FolderService {
  // 내가 속한 팀에 공유된 폴더 목록
  static async getSharedFolders() {
    const response = await apiService.client.get<ApiEnvelope>('/folders/shared')
    return response.data
  }

  // 폴더를 팀에 공유
  static async shareFolder(folderId: string, data: ShareFolderInput) {
    const response = await apiService.client.post<ApiEnvelope>(
      `/folders/${folderId}/share`,
      data
    )
    return response.data
  }

  // 공유 폴더 권한 설정
  static async updatePermissions(
    folderId: string,
    data: FolderPermissionsInput
  ) {
    const response = await apiService.client.put<ApiEnvelope>(
      `/folders/${folderId}/permissions`,
      data
    )
    return response.data
  }

  // 폴더 공유 해제
  static async unshareFolder(folderId: string) {
    const response = await apiService.client.delete<ApiEnvelope>(
      `/folders/${folderId}/unshare`
    )
    return response.data
  }
}

export default FolderService
